export enum TripTypeIR {
	Select = 1,
	IFG = 2,
	IFB = 3,
	Comp = 4,
	Invited = 5,
}
